import templateStr from 'text!./templates/ho-quote-offering.html';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            customQuote: '=',
            customOffering: '=',
            standardOffering: '=',
            buy: '=',
            customQuoteForm: '='
        },
        controller: ['$scope', '$filter', 'ModalService', 'ViewModelService', 'qnb.CustomQuoteService', function ($scope, $filter, ModalService, ViewModelService, CustomQuoteService) {
            $scope.quoteStatus = {
                calculatingQuote: false,
                showLoading: false,
                displayed: false,
                isStale: false
            };
            $scope.view = ViewModelService.create($scope.customQuote, 'pc', 'edge.capabilities.quote.submission.dto.CustomQuoteDTO');

            $scope.markStale = function () {
                $scope.quoteStatus.isStale = true;
            };

            $scope.buyQuote = function () {
                if (!$scope._validateInputFields()) {
                    return;
                }
                $scope.buy.apply(null, arguments);
            };

            $scope.syncCoverage = function () {
                $scope.quoteStatus.isStale = true;
                if (!$scope._validateInputFields()) {
                    return;
                }

                $scope.quoteStatus.showLoading = true;
                var operation = CustomQuoteService.updateCustomQuoteCoverages($scope.customQuote);
                operation.then(function (quote) {
                    $scope.customOffering.lobs = quote.coverages;
                    $scope.view.coverages.value = quote.coverages; // Update view otherwise UI is stale
                });
                operation.catch(self._handleQuoteError);
                operation.finally(function () {
                    $scope.quoteStatus.showLoading = false;
                    $scope.customQuoteForm.submitted = false;
                });
            };

            $scope.updateQuote = function () {
                if (!$scope._validateInputFields()) {
                    return;
                }

                $scope.quoteStatus.calculatingQuote = true;

                var operation = CustomQuoteService.updateCustomQuote($scope.customQuote);
                operation.then(function (updatedCustomQuote) {
                    $scope.customQuote.coverages = updatedCustomQuote.coverages;
                    $scope.customQuote.quote = updatedCustomQuote.quote;
                    $scope.quoteStatus.isStale = false;
                });
                operation.catch(self._handleQuoteError);
                operation.finally(function () {
                    $scope.quoteStatus.calculatingQuote = false;
                    $scope.customQuoteForm.submitted = false;
                });
            };

            $scope._handleQuoteError = function (error) {
                var message = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid Coverage Option');
                var description = $filter('translate')('integration.quoteandbind.directives.custom-quote.Sorry, but that coverage option is invalid, please select a different value');
                ModalService.showError(message, description);
                console.log('Error updating custom quote', error);
            };

            /**
             * Checks that there are no invalid inputs or nested forms, displays a modal prompting the user to
             * fix errors.
             *
             * @returns {boolean}
             */
            $scope._validateInputFields = function () {
                if (!$scope.view.aspects.subtreeValid) {
                    var message = $filter('translate')('integration.quoteandbind.directives.custom-quote.Invalid input values');
                    var description = $filter('translate')('integration.quoteandbind.directives.custom-quote.Please correct input field errors');
                    ModalService.showError(message, description);
                    $scope.customQuoteForm.submitted = true;
                    return false;
                }
                // If the form is valid then reset the submitted value. So pristine fields are not marked with errors
                $scope.customQuoteForm.submitted = false;
                return true;
            };

            // If there is no standard offering then the custom quote content must be visible
            var standardOfferingIsNotDefined = !angular.isDefined($scope.standardOffering);
            if (standardOfferingIsNotDefined) {
                $scope.quoteStatus.displayed = true;
            }
        }],
        'link': function link(scope, elt) {
            elt[0].addEventListener('change', function () {
                scope.quoteStatus.isStale = true;
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/directives/HOQuoteOffering.js
// module id = 2154
// module chunks = 0